import styled from 'styled-components';
import theme from 'src/theme';

export const StatusIconWrapper = styled.span`
    #sequence-changed-marker {
        font-size: smaller;
        color: ${theme.colors.background.portNode};
    }
`;
